<script>
/* global locale*/
import FetchCall from '../../../shared/local_fetch_call'
import Hotel from '../../../classes/hotel'
import { mapMutations } from 'vuex'

export default {
  methods: {
    ...mapMutations('hotel', [
      'clearNonContractedHotels',
      'setRetailLoading',
      'updateHotelsArray',
      'setLoading'
    ]),
    async fetchAvailableHotels(latitude, longitude, checkIn, checkOut, roomQty) {
      let res = await FetchCall.fetchWithoutLocale(
        '/api/h4h_hotels' +
        `?latitude=${latitude}` +
        `&longitude=${longitude}` +
        `&inDate=${checkIn}` +
        `&outDate=${checkOut}` +
        `&rooms=${roomQty}`,
        'GET',
        null
      )

      this.setRetailLoading(false)
      this.hotels = res.ArnResponse.Availability.HotelAvailability.Hotel
      this.createHotelObject(false)
    },
    async createHotelObject(isContracted) {
      const checkIn = isContracted ?
        this.$store.state.hotel.contractedCheckInDate :
        this.$store.state.hotel.checkInDate
      const checkOut = isContracted ?
        this.$store.state.hotel.contractedCheckOutDate :
        this.$store.state.hotel.checkOutDate

      const stayDuration =
        (checkOut - checkIn) / (1000*3600*24)

      this.clearNonContractedHotels()

      let hotelsArray = []

      for (let i = 0; i < this.hotels.length; i++) {
        const hotel = new Hotel(this.hotels[i], isContracted)
        if (!hotel.id || hotel.rooms.length === 0) continue
        if (isContracted) {
          await hotel.updateHotelInfo(this.$store.state.hotel.eventLatitude, this.$store.state.hotel.eventLongitude)
        } else {
          hotel.updateHotelInfo(this.$store.state.hotel.eventLatitude, this.$store.state.hotel.eventLongitude)
        }
        hotel.checkIn = new Date(checkIn).toLocaleDateString(locale,
          {month: 'numeric', day: 'numeric', year: 'numeric'})
        hotel.checkOut = new Date(checkOut).toLocaleDateString(locale,
          {month: 'numeric', day: 'numeric', year: 'numeric'})
        hotel.stayDuration = Math.ceil(stayDuration)
        hotelsArray.push(hotel)
      }
      this.updateHotelsArray(hotelsArray)
      if (!this.orderItem || !this.orderItem.h4h_hotel_attributes.hotel_id) {
        this.setLoading(false)
      }
    }
  }
}
</script>
